import { memo } from 'react';
import { Redirect } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { useSelector } from '@client/hooks/redux.hooks';
import { getSessionPathForUser } from '@client/selectors/helpers/session';

export default memo(() => {
  const sessionPathForUser = useSelector(getSessionPathForUser);

  if (sessionPathForUser === null) {
    return <CircularProgress />;
  }

  return <Redirect to={sessionPathForUser} />;
});
